import React from 'react';

// =====================================================================
// Task 3.2: ImportantToggle
//
// A pure controlled boolean switch with the inline label "Mark as Important".
// =====================================================================

interface ImportantToggleProps {
  value: boolean;
  onChange: (next: boolean) => void;
  // Optional: id used to associate label with the input for accessibility.
  id?: string;
  // Optional: disabled state passed through.
  disabled?: boolean;
}

export const ImportantToggle: React.FC<ImportantToggleProps> = ({
  value,
  onChange,
  id,
  disabled,
}) => {
  const inputId = id ?? 'important-toggle';
  return (
    <label
      htmlFor={inputId}
      className="inline-flex items-center gap-2 cursor-pointer select-none"
    >
      <input
        id={inputId}
        type="checkbox"
        role="switch"
        aria-checked={value}
        checked={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 accent-amber-500"
      />
      <span className="text-sm text-gray-800">Mark as Important</span>
    </label>
  );
};

// =====================================================================
// Task 3.3: ImportantWarningAlert
//
// Renders the verbatim warning text exactly. NO Sentence-Casing, NO trailing
// period, NO extra characters, NO substitution.
// =====================================================================

export const IMPORTANT_WARNING_TEXT =
  'this note will always on top, and you can remove the important after that';

export const ImportantWarningAlert: React.FC = () => (
  <div
    role="alert"
    className="mt-2 rounded-md bg-amber-50 border border-amber-200 px-3 py-2 text-sm text-amber-900"
  >
    {IMPORTANT_WARNING_TEXT}
  </div>
);
